<template>
	<CRow
		align-horizontal="center"
		class="container-action-submit"
	>
		<CCol
			v-if="removeText"
			lg="3"
			class="d-flex align-items-center"
		>
			<CRow align-horizontal="end">
				<CCol class="p-0">
					<CButton
						class="btn-remove p-0"
						@click="$emit('onRemove')"
					>
						{{ removeText }}
					</CButton>
				</CCol>
			</CRow>
		</CCol>
		<CCol>
			<CRow align-horizontal="end">
				<CCol class="text-right p-0">
					<CButton
						v-if="cancelText"
						class="btn-cancel flex btn-new-user transparent mr-3"
						color="tertiary"
						@click="$emit('onCancel')"
					>
						{{ cancelText }}
					</CButton>
					<CButton
						v-if="submitText"
						:disabled="isLoading"
						class="btn-submit flex transparent btn-export-csv"
						color="primary"
						@click="$emit('onSubmit')"
					>
						{{ submitText }}
					</CButton>
				</CCol>
			</CRow>
		</CCol>
	</CRow>
</template>

<script>
export default {
	name: 'BaseActionSubmit',

	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		submitText: {
			type: String,
			default: '',
		},
		cancelText: {
			type: String,
			default: '',
		},
		removeText: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss" scoped>
.container-action-submit {
	margin: rem(40) auto;

	.btn-cancel,
	.btn-submit {
		min-width: rem(132);
	}

	.btn-cancel {
		margin-left: rem(34);
	}
}
</style>